import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeleteTestingActionMutation} from '../hooks/useTestingActionsQuery';
import {useTestingActionsSelection} from '../hooks/useTestingActionsSelection.ts';

export const DeleteRecordButton = () => {

    const deleteMutation = useDeleteTestingActionMutation();

    const {
        selection,
        handleClearSelection,
    } = useTestingActionsSelection();

    const recordIds = Object.keys(selection)
                            .filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);
};
